import React from "react";
import styled from "styled-components";


const Wrapper = styled.div`
    p{
      font-weight: bold;
       color: #515151;
    }
`

const MainWrapper = styled.div`
    min-height: 50vw;
    padding-top: 40px;
    display: flex;

    align-items: center;
    //justify-content: center;
    @media only screen and (max-width: 600px) {
      flex-direction: column;
    }
    .imageWrapper{
      width: 5%;
      @media only screen and (max-width: 600px) {
        display: none;
      }
      padding: 2vw 4vw;
    }
    
    
   
    
`
const ImageWrapper = styled.div`
  position: relative;
  img{
      position: absolute;
      width: 60vw;
      left: -5vw;
      top: -35vw;
      z-index: -1;
  }
`
const ContentWrapper = styled.div`
    width: 50%;
      @media only screen and (max-width: 600px) {
         width: 100%;
         h2{
         text-align: center;
         }
         p{
         text-align: justify;
         }
      }
`

const WhyBlock = () => (
    <MainWrapper className={'b10'}>
        <ContentWrapper>
            <h2>ПОЧЕМУ ЭТО СРАБОТАЕТ?</h2>
            <Wrapper>
                <p>Мы – одно целое.</p>
                <p>Как только мы поддержим друг друга, проявим смелость, солидарность и взаимовыручку и поверим в свою неизбежную победу, режим падет. От Лукашенко откажутся все, кто сейчас выполняет его преступные приказы. Каждому страшно быть первым, каждому страшно проиграть. Но наша сила в том, что мы знаем – нас большинство.</p>
                <p>А вместе мы – самая большая сила!</p>
            </Wrapper>
        </ContentWrapper>
        <ImageWrapper className={'imageWrapper'}>
            <img src={'/block-2.jpg'}/>
        </ImageWrapper>

    </MainWrapper>
)

export default WhyBlock;
